import { cn } from '@creator/ui/utils/ui';
import AdvertisingSlot from '@src/components/Ads/AdvertisingSlot';
import React, { type FC, memo } from 'react';

export interface TokenSidebarProps {
    tokenName: string;
    className?: string;
}
const TokenSidebar: FC<TokenSidebarProps> = props => {
    const { className, tokenName } = props;

    function renderAd() {
        return <AdvertisingSlot location="mid_right" tokenName={tokenName} />;
    }

    return <div className={cn('space-y-4', className)}>{renderAd()}</div>;
};

export default memo(TokenSidebar);
